import React from "react";
import { useNavigate } from "react-router-dom";
import NuevoAbonoForm from "components/abonos/AbonoForm";
import { confirmAlert, errorAlert } from "helpers/alerts";
import { createAbonoService } from "services/abonos/abonosService";

const CreateAbonoScreen = () => {
  const navigate = useNavigate();
  const handleSubmit = (data) => {
    createAbonoService(data)
      .then(() => {
        confirmAlert({
          title: "Listo",
          text: "Abono enviado correctamente.",
          showCancelButton: false,
        });
        navigate(-1);
      })
      .catch((error) => errorAlert(error));
  };

  return (
    <NuevoAbonoForm
      title={"Nuevo Abono"}
      goBack={() => navigate(-1)}
      submit={handleSubmit}
    />
  );
};

export default CreateAbonoScreen;
